// extracted by mini-css-extract-plugin
export var alt = "HotelSearchModal-module--alt--f7ea8";
export var desktopOnly = "HotelSearchModal-module--desktopOnly--1ff7d";
export var main = "HotelSearchModal-module--main--d940c";
export var mobileOnly = "HotelSearchModal-module--mobileOnly--4911e";
export var modalOpen = "HotelSearchModal-module--modal-open--b0de9";
export var styledContainer = "HotelSearchModal-module--styledContainer--31a28";
export var styledModal = "HotelSearchModal-module--styledModal--f981e";
export var textLeft = "HotelSearchModal-module--textLeft--830d9";
export var visuallyHidden = "HotelSearchModal-module--visuallyHidden--f7da4";